export default (key) => {
    return window.localStorage.getItem(key);
};
